import React from 'react';
import { useCurrency } from '../context/CurrencyContext';
import './CurrencySwitcher.css';

export default function CurrencySwitcher() {
  const { currency, setCurrency, supported } = useCurrency();
  return (
    <select
      className="currency-switcher"
      value={currency}
      onChange={(e) => setCurrency(e.target.value)}
      aria-label="Display currency"
      title={`Showing prices in ${currency} — checkout always in CAD`}
    >
      {supported.map(c => <option key={c} value={c}>{c}</option>)}
    </select>
  );
}
